import { useStandardsFetch } from "./useStandardsFetch";
import { useStandardsQuery } from "./useStandardsQuery";

export { useStandardsFetch, useStandardsQuery };
